// @mui material components
import {
  CircularProgress,
  Backdrop,
  Snackbar,
  Alert,
  Card,
  Grid,
  // Grid,
  // MenuItem,
  // Select,
  // FormControl,
  // InputLabel,
  // Dialog,
  // DialogContent,
  Icon,
  Divider,
  // Container,
  IconButton,
  Button,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
// import axios from "axios.js";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import usePageTitle from "app/pageTitle";
import { Height } from "@mui/icons-material";

function TasksPage() {
  const pageTitle = "My Tasks";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
    setSeverity("error");
    setShowLoading(false);
  };

  const taskCategories = [
    {
      url: "/tasks/sales",
      icon: "receipt",
      name: "Sales",
    },
    {
      url: "/tasks/data",
      icon: "edit_note",
      name: "Data Capture",
    },
    {
      url: "/tasks/psa",
      icon: "inventory_alt",
      name: "Product Sampling",
    },
    {
      url: "/tasks/daw",
      icon: "store",
      name: "Display and Win",
    },
    {
      url: "/tasks/call_center",
      icon: "support_agent",
      name: "Call Center",
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={1} mb={5}>
        <MDBox mb={1}>
          <Button
            color="dark"
            startIcon={<Icon>west</Icon>}
            onClick={() => navigate("/dashboard")}
          >
            Back to Home
          </Button>
        </MDBox>
        <Grid container spacing={2.5}>
          {taskCategories.map((category) => (
            <Grid item xs={6} md={6} lg={6}>
              <MDBox
                sx={{ height: "100%" }}
                onClick={() => navigate(category.url)}
              >
                <Card sx={{ height: "100%" }}>
                  <MDBox p={2}>
                    <MDBox align="center">
                      <MDTypography variant="h6" fontSize={13}>
                        {category.name}
                      </MDTypography>
                    </MDBox>
                    <MDBox>
                      <Divider />
                    </MDBox>
                    <MDBox mt={3} align="center">
                      <MDTypography fontSize={24}>
                        <Icon>{category.icon}</Icon>
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            </Grid>
          ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TasksPage;
